import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { HelpCircle, Mail } from 'lucide-react';

const ClientHelpSupport = () => {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold">Help & Support</h2>
        <p className="text-muted-foreground mt-1">Get assistance with your account</p>
      </div>

      {/* Support Card */}
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2">
            <HelpCircle className="h-5 w-5 text-primary" />
            <CardTitle>Need Assistance?</CardTitle>
          </div>
          <CardDescription>We're here to help</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            If you have any questions or need help with your account, please contact your Appsytec account manager or reach out to our support team.
          </p>
          <Button variant="outline" asChild>
            <a href="mailto:contact+portalhelp@appsytec.com?subject=Portal Support Request">
              <Mail className="mr-2 h-4 w-4" />
              Contact Support
            </a>
          </Button>
        </CardContent>
      </Card>

      {/* FAQ Card */}
      <Card>
        <CardHeader>
          <CardTitle>Frequently Asked Questions</CardTitle>
          <CardDescription>Common questions and answers</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <h4 className="font-medium mb-2">How do I request candidate details?</h4>
            <p className="text-sm text-muted-foreground">
              It's best to email us at <a href={`mailto:contact@appsytec.com`}>contact@appsytec.com</a> specifying which candidate/s you're enquiring about and what information you require. Clicking the "Request Details" button on the Candidates search page will launch your default email client with a draft to email us for the specific candidate.
            </p>
          </div>
          <div>
            <h4 className="font-medium mb-2">How do I update my contact information?</h4>
            <p className="text-sm text-muted-foreground">
              Visit the My Details page to update your name, position, phone, branch, and division. To change your email address, please contact support.
            </p>
          </div>
          <div>
            <h4 className="font-medium mb-2">How do I manage notification preferences?</h4>
            <p className="text-sm text-muted-foreground">
              Go to Settings to configure your email notification preferences for applications, status updates, and messages.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ClientHelpSupport;
